export const NotificationStatus = {
  NEW: 'new',
  SEEN: 'seen',
  READ: 'read',
};

export const DEFAULT_GET_NOTI_PARAMS = {
  limit: 30,
  offset: 0,
};
